import { ApiPage, emptyApiPage } from "../models/api-page.model";
import { Contact, CreateContact } from "../models/contact.model";
import { apiService } from "./api.service";
import { ApiError, ApiErrorCode } from "../models/api-error.model";

export class ContactService {
  private static BASE_PATH = "/api/v1/offices";

  static async getContact(contactId: string, officeId: string): Promise<Contact | null> {
    const response = await apiService.get(`${this.BASE_PATH}/${officeId}/contacts/${contactId}`);
    if (!response.success) return null;

    return response.data as Contact;
  }

  static async searchContacts(
    officeId: string,
    page = 0,
    size = 10,
    sort = "company,asc",
    term?: string,
    contactType?: string
  ): Promise<ApiPage<Contact>> {
    const payload: any = { searchTerm: term };
    if (contactType) payload.contactType = contactType;
    const response = await apiService.post(`${this.BASE_PATH}/${officeId}/contacts/search?page=${page}&size=${size}&sort=${sort}`, payload);
    if (!response.success) return emptyApiPage<Contact>();

    return response.data as ApiPage<Contact>;
  }

  // Returns saved office with ID included, or throws ApiError on failure
  static async addContact(contact: CreateContact, officeId: string): Promise<Contact> {
    const response = await apiService.post(`${this.BASE_PATH}/${officeId}/contacts`, contact);
    if (!response.success) {
      const errorMessage = response.data?.message || "Failed to add contact";
      const errorCode = response.status === 409 ? ApiErrorCode.EXISTS : ApiErrorCode.BAD_REQUEST;
      throw new ApiError(errorCode, errorMessage);
    }

    return response.data as Contact;
  }

  static async updateContact(contact: CreateContact, officeId: string, contactId: string): Promise<Contact> {
    const response = await apiService.put(`${this.BASE_PATH}/${officeId}/contacts/${contactId}`, contact);
    if (!response.success) {
      const errorMessage = response.data?.message || "Failed to update contact";
      const errorCode = response.status === 409 ? ApiErrorCode.EXISTS : ApiErrorCode.BAD_REQUEST;
      throw new ApiError(errorCode, errorMessage);
    }

    return response.data as Contact;
  }

  static async deleteContact(officeId: string, contactId: string): Promise<boolean> {
    const response = await apiService.delete(`${this.BASE_PATH}/${officeId}/contacts/${contactId}`);
    if (!response.success) return false;

    return true;
  }

  static async bulkUploadContact(file: FormData, officeId: string): Promise<string | null> {
    const response = await apiService.post(`${this.BASE_PATH}/${officeId}/contacts/create-bulk`, file);
    if (!response.success) return null;

    return response.data as string;
  }
}
